<section class="policy-content terms-content" appReveal>
  <div class="policy-content__inner">

    <!-- Section 1: 訂單確認 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@terms.order.heading">訂單確認</h2>
      <p class="policy-content__paragraph" i18n="@@terms.order.p1">成功下單後，閣下會收到一封由系統發出的訂單摘要電郵。訂單所有內容將以此電郵為準。</p>
      <p class="policy-content__paragraph" i18n="@@terms.order.p2">如閣下於下單後1小時內仍未收到確認電郵，並已查看閣下的垃圾郵件夾，請通知姓名、電話號碼及下單時所輸入的電郵地址與我們聯絡。</p>
      <p class="policy-content__paragraph" i18n="@@terms.order.p3">訂單一經確定，不設退款。</p>
    </div>

    <hr class="policy-content__divider">

    <!-- Section 2: 查詢 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@terms.inquiries.heading">如有任何查詢可致電或電郵給我們</h2>
      <p class="policy-content__paragraph">
        <span class="policy-content__label" i18n="@@terms.inquiries.email.label">Email：</span>order@chouxcreme.com.hk<span class="terms-content__hours-suffix" i18n="@@terms.inquiries.hoursSuffix">　星期一至星期五</span>
      </p>
      <p class="terms-content__hours" i18n="@@terms.inquiries.hours">星期一至星期五</p>
      <p class="policy-content__paragraph">
        <span class="policy-content__label" i18n="@@terms.inquiries.tel.label">Tel：</span>26901853<span class="terms-content__hours-suffix" i18n="@@terms.inquiries.telHours">　星期一至星期五（10:00-13:00 | 14:00-18:00）</span>
      </p>
      <p class="terms-content__hours" i18n="@@terms.inquiries.telHoursMobile">星期一至星期五（10:00-13:00 | 14:00-18:00）</p>
    </div>

    <hr class="policy-content__divider">

    <!-- Section 3: 付款方式 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@terms.payment.heading">付款方式</h2>
      <ol class="policy-content__list policy-content__list--ordered">
        <li class="policy-content__list-item" i18n="@@terms.payment.step1">可以透過網上直接完成付款 (八達通, 支付寶, 信用卡, 微信支付, PayMe 等等), 完成付款後, 會收到訂單確實郵件。</li>
        <li class="policy-content__list-item" i18n="@@terms.payment.step2">若選擇轉數快或轉帳到公司戶口內, 完成付款後請閣下拍下照片傳送給我們 (WhatsApp 9568 9068)，經確定後, 會收到訂單確實郵件。</li>
      </ol>

      <div class="policy-content__callout terms-content__callout">
        <p class="policy-content__callout-line"><span class="policy-content__label" i18n="@@terms.payment.fps.label">轉數快：</span>169734233 J-Sweets Co.,Ltd</p>
        <p class="policy-content__callout-line"><span class="policy-content__label" i18n="@@terms.payment.hsbc.label">HSBC Bank A/C：</span>819-161233-838</p>
        <p class="policy-content__callout-line"><span class="policy-content__label" i18n="@@terms.payment.companyName.label">Company Name：</span>J-S****S C* LIM***D</p>
      </div>

      <div class="terms-content__contact-block">
        <p class="policy-content__paragraph">
          <span class="policy-content__label" i18n="@@terms.payment.whatsapp.label">WhatsApp：</span>9568 9068<span class="terms-content__hours-suffix" i18n="@@terms.payment.whatsappHours">　星期一至星期五（09:00-18:00）</span>
        </p>
        <p class="terms-content__hours" i18n="@@terms.payment.whatsappHoursMobile">星期一至星期五（09:00-18:00）</p>
        <p class="policy-content__paragraph">
          <span class="policy-content__label" i18n="@@terms.payment.email.label">Email：</span>order@chouxcreme.com.hk<span class="terms-content__hours-suffix" i18n="@@terms.payment.emailHours">　星期一至星期五（09:00-18:00）</span>
        </p>
        <p class="terms-content__hours" i18n="@@terms.payment.emailHoursMobile">星期一至星期五（09:00-18:00）</p>
      </div>

      <p class="terms-content__note" i18n="@@terms.payment.note">請注意：不接受支票付款，或若以不同銀行網上轉帳，可能收取手續費及需待數天後才能確定訂購項目。</p>
    </div>

    <hr class="policy-content__divider">

    <!-- Section 4: Dispute notice -->
    <div class="policy-content__section" appReveal="100">
      <p class="policy-content__paragraph" i18n="@@terms.dispute">如有任何爭議，J-Sweets Co.,Ltd 保留最終決定權。</p>
    </div>

  </div>
</section>
